import React, { useState } from 'react';

import CloseIcon from '@images/icons/x-mark.webp';

import '../promotions/styles/promotions.scss';
import ReactMarkdown from 'react-markdown';
import CloudflareImage from '../cloudflare-image/CloudflareImage';
import useIsMobile from '../../hooks/useIsMobile';
import { setCookie } from '../../utils/cookies';
import usePromotionBanners from '../promotions/usePromotionBanners';

const OldPromo = () => {
  const isMobile = useIsMobile();
  const [showBanner, setShowBanner] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
    setCookie('hidebnab', true, 7);
  };
  const { dismissBanner } = usePromotionBanners({
    showBanner: showBanner,
    setShowBanner: setShowBanner,
    isMobile: isMobile,
  });

  return (
    isVisible &&
    isVisible !== null && (
      <div className="promotions" data-aos="fade-down">
        <div>
          <p className="h4">
            <ReactMarkdown components={{ p: React.Fragment }} children={undefined} />
            ZeroBounce Sitewide Sale: Save 15% on all ZeroBounce services.
            <br />
            <span>&nbsp; Use promo code: AUG15 at checkout.</span>
          </p>
        </div>

        <button type="button" className="close__panel" onClick={handleClose}>
          <CloudflareImage src={CloseIcon} alt="close" width="30" height="30" loading="lazy" decoding="async" />
        </button>
      </div>
    )
  );
};

export default OldPromo;
